// @ts-nocheck
import createSingleServiceWidget from './createSingleServiceWidget';
import { isResponsiveEditor } from '@wix/santa-editor-utils';
export default ({ editorAPI }) =>
  createSingleServiceWidget({
    editorAPI,
    isEditorX: isResponsiveEditor(),
  });
